module.exports = __webpack_public_path__ + "static/media/cronometer-banner.b3aded3b.svg";